import { render, staticRenderFns } from "./TabelaResultadosFormularios.vue?vue&type=template&id=bf325be8&scoped=true&"
import script from "./TabelaResultadosFormularios.vue?vue&type=script&lang=js&"
export * from "./TabelaResultadosFormularios.vue?vue&type=script&lang=js&"
import style0 from "./TabelaResultadosFormularios.vue?vue&type=style&index=0&id=bf325be8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf325be8",
  null
  
)

export default component.exports